import { PaymentMethodType, PricingInformation } from '@platform-frontend/marketplace';

export class CheckWalletSupport {
  static readonly type = '[PaymentWallet] Check Wallet Support';
  constructor(public allowedPaymentMethods: PaymentMethodType[], public isProductLive: boolean) {}
}

export class CheckWalletAutoSelection {
  static readonly type = '[PaymentWallet] Check Wallet Auto Selection';
}

export class ValidateApplePaySession {
  static readonly type = '[PaymentWallet] Validate Apple Pay Session';
  constructor(public pricingInformation: PricingInformation, public session: ApplePaySession) {}
}
